// Centralised site config â used across pages so values stay consistent.
export const SITE = {
    brand: "CPR Paint & Coatings",
    tagline: "Commercial Â· Painting Â· Resource",
    serviceArea: "Utah",
    serviceAreaExtended: "Utah and the surrounding states",
    phoneDisplay: "(435) 555-0100",
    phoneLink: "+143****0100",
    email: "hello@cprpainting.com",
    hours: "Monday â Friday Â· 7:00am â 6:00pm",
    address: "Utah",
    copyrightLine: "CPR Paint & Coatings",
};

export const SERVICES = [
    {
        slug: "commercial",
        title: "Commercial Painting",
        short: "Reliable crews, minimal disruption, professional results.",
        long: "Offices, retail, multi-unit, and light industrial. We schedule around your business â including evenings and weekends â and keep work zones contained so your operation keeps moving.",
        steps: [
            "Site visit & scope of work",
            "Schedule designed around your operations",
            "Contained workspaces & nightly cleanup",
            "Final QA walk with property manager",
        ],
        image: "/img/service-commercial.png",
    },
    {
        slug: "specialty",
        title: "Specialty Finishes",
        short: "Epoxy coatings, intumescent fireproofing, cabinetry, fences, and decks.",
        long: "Epoxy floor coatings and intumescent fireproofing come first â the work that matters most for both commercial clients and homeowners. From garage floor epoxy, often the first thing a homeowner looks at in specialty, to fire-rated intumescent coatings for commercial buildings, we handle it. We also refinish cabinets, stain decks, and seal fences â the detail work that makes a property feel finished.",
        steps: [
            "Sample & finish approval",
            "Disassembly & professional spray prep where needed",
            "Multi-coat finish with proper cure times",
            "Reinstall & final touch-up",
        ],
        image: "/img/service-specialty.png",
    },
    {
        slug: "exterior",
        title: "Exterior Painting",
        short: "Curb appeal that lasts â quality exterior finishes.",
        long: "Siding, trim, fascia, fences, and decks. Mountain weather is hard on a house â we power-wash, scrape, prime, and apply weather-resistant finishes built for Utah seasons.",
        steps: [
            "Pressure wash & full surface inspection",
            "Scrape, caulk, repair, prime bare areas",
            "Two-coat application with weather-rated paint",
            "Crew clean-up and walk-around with you",
        ],
        image: "/img/service-exterior.png",
    },
    {
        slug: "interior",
        title: "Interior Painting",
        short: "Transform your home's interior with precision and care.",
        long: "Walls, ceilings, trim, doors, and cabinets. We handle every prep detail â patching, sanding, priming, and protecting your floors and furniture â so the finished work looks clean, sharp, and lasts.",
        steps: [
            "Walkthrough & color consultation",
            "Surface prep, patching, sanding, priming",
            "Cut-in & roller application with premium paint",
            "Final inspection & clean job-site handoff",
        ],
        image: "/img/service-interior.png",
    },
];

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/services", label: "Services" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Get a Quote" },
];
